import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import style from './PolymarketTile.module.css';

const PolymarketTile = ({ stock }) => {
  const [markets, setMarkets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMarkets = async () => {
      try {
        const response = await fetch(`/react/polymarket?stock_id=${stock.id}`, { credentials: 'omit' });

        if (response.ok) {
          const data = await response.json();
          setMarkets(data);
        } else {
          console.error('Error fetching Polymarket data:', response.status);
        }
      } catch (error) {
        console.error('Error fetching Polymarket data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (stock && stock.id) {
      fetchMarkets();
    }
  }, [stock]);

  if (loading) return null; // Or a loading spinner
  if (!markets || markets.length === 0) return null;

  return (
    <div className={style.container}>
      <div className={style.headline}>
        Polymarket Forecasts
        <a href={`/stocks/${stock.symbol}/polymarket`} className={style.viewAll}>
          View all
        </a>
      </div>
      <div className={style.marketContainer}>
        {markets.map((market) => (
          <a 
            key={market.id} 
            href={market.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className={style.marketCard}
          >
            <span className={style.question}>{market.question}</span>
            <div className={style.barContainer}>
              <div 
                className={style.barFill} 
                style={{ width: `${market.probability * 100}%` }}
              />
            </div>
            <div className={style.stats}>
              <span>Chance</span>
              <span className={style.probability}>
                {Math.round(market.probability * 100)}%
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

PolymarketTile.propTypes = {
  stock: PropTypes.object.isRequired
};

export default PolymarketTile;
